import { v4 } from 'uuid';
import { Model } from './model';

export function createMockPlan(overrides: Partial<Model> = {}): Model {
  return {
    id: `pln_${v4().replace(/-/g, '')}`,
    order: 0,
    created: new Date(),
    modified: new Date(),
    deleted: null,
    title: 'Mock Plan',
    description: null,
    visible: true,
    liabilityPerClaim: false,
    planLiabilityLimit: 0,
    conditions: null,
    policyId: `pol_${Math.random().toString(36).substring(2, 10)}`,
    addons: [],
    liabilityGroups: null,
    coverageConfigs: {},
    ...overrides,
  };
}
